import type { MenuDefinition } from '@1js/acui-menu/lib/components/MenuDefinition';
import type { RibbonFlyoutAnchorProps } from '@1js/acui-ribbon-like/lib/UISurfaces/Ribbon';
import { computedFn } from 'mobx-utils/lib/computedFn';
import { getComposeRibbonId } from 'owa-compose-ribbon-utils/lib/utils/getComposeRibbonId';
import AppsAddIn from 'owa-fluent-icons-svg/lib/icons/AppsAddInRegular';
import Attach from 'owa-fluent-icons-svg/lib/icons/AttachRegular';
import CalendarClockRegular from 'owa-fluent-icons-svg/lib/icons/CalendarClockRegular';
import ClipboardPaste from 'owa-fluent-icons-svg/lib/icons/ClipboardPasteRegular';
import Important from 'owa-fluent-icons-svg/lib/icons/ImportantRegular';
import SaveRegular from 'owa-fluent-icons-svg/lib/icons/SaveRegular';
import FontColor from 'owa-fluent-icons-svg/lib/icons/TextColorRegular';
import GrammarCheck from 'owa-fluent-icons-svg/lib/icons/TextGrammarCheckmarkFilled';
import loc from 'owa-localize';
import GroupStrings from 'owa-locstrings/lib/strings/ribbon_mail_groups.locstring.json';
import type { ComposeViewState } from 'owa-mail-compose-store';
import type { RibbonGroupId } from 'owa-ribbon-ids';
import { MailRibbonGroupId } from 'owa-ribbon-ids';
import { createMailAppFlyoutAnchor } from '../../../util/createMailRibbonButton';

const emptyMenuDefinition: MenuDefinition = {
    sections: [],
};

export const getMLRM3MessageTabCommonGroupFlyout = computedFn(
    (
        group: RibbonGroupId,
        popoutComposeViewState?: ComposeViewState
    ): RibbonFlyoutAnchorProps | undefined => {
        const isPopout: boolean = popoutComposeViewState != undefined;
        const groupId = getComposeRibbonId(group, popoutComposeViewState).toString();
        switch (group) {
            case MailRibbonGroupId.Group_Clipboard_M3Message:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.clipboard_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    ClipboardPaste
                );

            case MailRibbonGroupId.Group_BasicText_M3Message:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.basicText_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    FontColor
                );

            case MailRibbonGroupId.Group_Include_M3Message:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.include_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    Attach
                );

            case MailRibbonGroupId.Group_AddIns_M3Message:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.addIns_GroupButton),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    AppsAddIn
                );

            case MailRibbonGroupId.Group_Tags_M3Message:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.tags_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    Important
                );

            case MailRibbonGroupId.Group_Save_M3Message:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.save_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    SaveRegular
                );

            case MailRibbonGroupId.Group_FindTime_M3Message:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.findTime_GroupButton),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    CalendarClockRegular
                );
            case MailRibbonGroupId.Group_Proofing:
                return createMailAppFlyoutAnchor(
                    groupId,
                    loc(GroupStrings.proofing_Group),
                    undefined /*tooltip*/,
                    isPopout,
                    emptyMenuDefinition,
                    undefined /* keytipProps */,
                    GrammarCheck
                );

            default:
                return undefined;
        }
    }
);
